import { Component, OnInit } from "@angular/core";
import { UntypedFormGroup, UntypedFormBuilder, Validators } from "@angular/forms";
import { ValidationService } from "src/app/core/validation.service";
import { AuthService } from "src/app/core/auth/auth.service";
import { Router, Params, ActivatedRoute } from "@angular/router";
import { AlertService } from "src/app/core/alert/alert.service";
import { Subscription } from "rxjs";
import { ActivateUser } from "src/app/pages/user/user-layout/shared/models/activate-account";

@Component({
standalone: false,
  selector: "app-set-new-password",
  templateUrl: "./set-new-password.component.html",
  styleUrls: ["./set-new-password.component.scss"],
})
export class SetNewPasswordComponent implements OnInit {
  setNewPassword: UntypedFormGroup;
  private route$: Subscription;
  token: string = '';
  validationMessage: any;
  isLoading: boolean;
  email: string = '';
  showPassword: boolean = false

  constructor(
    private formBuilder: UntypedFormBuilder,
    private validationMessages: ValidationService,
    private route: ActivatedRoute,
    private authService: AuthService,
    private router: Router,
    public alertService: AlertService
  ) {
    this.validationMessage = validationMessages;
  }

  ngOnInit() {
    this.initializeForm();
    this.route$ = this.route.params.subscribe((params: Params) => {
      this.token = params["token"];
      this.email = params["email"]
    });
    this.isLoading = false;
  }

  initializeForm() {
    this.setNewPassword = this.formBuilder.group({
      newPassword: ["", Validators.compose([Validators.required, Validators.minLength(8)])],
      verifyPassword: ["", Validators.compose([Validators.required, Validators.minLength(8)])],
    });
  }

  setPassword() {
    this.isLoading = true;
    const setPasswordObject = new ActivateUser();
    setPasswordObject.password = this.setNewPassword.value.newPassword;
    setPasswordObject.email = this.email;
    setPasswordObject.token = this.token;

    this.authService.setPassword(setPasswordObject).subscribe(
      (response) => {
        this.isLoading = false;
        this.alertService.success("Your reset was successful", true);
        this.router.navigate(["sign-in"]);
      },
      (error) => {
        this.alertService.error(error.error.message, false);
        this.isLoading = false;
      }
    );
  }

  toggleShowPassword() {
    var passwordInput = <HTMLInputElement>document.getElementById("newPassword");
    var toggleButton = document.querySelector(".toggle-password");
    
    if (passwordInput.type === "password") {
      passwordInput.type = "text";
      this.showPassword = !this.showPassword
    } else {
      passwordInput.type = "password";
      this.showPassword = !this.showPassword
    }
  }
}
